import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';

@Injectable({
  providedIn: 'root',
})
export class CoordinateSystemsApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public getAll(): Observable<IApiResponse<ICoordinateSystem[], object>> {
    const url = `${environment.apiBaseUrl}/v1/coordinate-systems`;

    return this.httpClient.get<IApiResponse<ICoordinateSystem[], object>>(url, {
      withCredentials: true,
    });
  }
}
